module.exports = __webpack_public_path__ + "static/img/siemens.d315cf06.png";